import { ChangeEvent } from 'react';
import { NumberInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types/FieldProps';

import JabraInput from 'components/Shared/JabraInput';
import { RichLabelProps } from 'components/Shared/JabraLabel';
import { usePrefillableValue } from 'src/hooks/usePrefillableValue';

const NumberInput: React.FC<ValueFieldProps<NumberInputViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const {  required } = field.model;
  const [value, setValue] = usePrefillableValue(
    field.model.name,
    props.value,
    props.onChange,
    field.valueField.name
  );
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const Label = props.labelComponent as React.FC<RichLabelProps>;

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value.replace(/\D/g, '');
    setValue(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  return (
    <>
      {!!Label && <Label {...props} />}
      <JabraInput
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        id={id}
        name={name}
        value={value}
        jssMetadata={props}
        required={required}
        onChange={onChange}
      />
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default NumberInput;
